// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2tSCP","fileDisabled":"File_fileDisabled__2IxK8"};